// import store, {state} from "../store/store";
// import {computed, ref, watchPostEffect} from "vue";
// import {useAssetActions} from "@/composables/lib/useAssetActions";
// import {getDocumentKey} from "@/composables/lib/getDocumentKey";
// import {
//     CREATE_ASSET,
//     DELETE_ASSET,
//     LIST_ASSETS,
// } from "@/store/operations";
// import {isArray, isObject, isString} from "@/lib/getVariableType";
// import config from "../../config";
//
// const {appId} = config
//
// export const useDocuments = (documentType, {refresh, parentDataType, parentRepoId, permissionHostDataType, permissionHostRepoId, isEphemeral} = {}) => {
//     const {dataType} = useAssetActions(documentType);
//     const parentKey = getDocumentKey({appId, dataType: parentDataType, repoId: parentRepoId});
//     const shouldLoadDocuments = computed(() => {
//         let pass = false;
//
//         const isLoaded = documents.value?.length;
//         pass ||= !isLoaded || refresh;
//
//         const isLoggedIn = state.user?.name;
//         pass &&= isLoggedIn || dataType !== "UserAccount";
//
//         return pass;
//     });
//
//     const documents = computed(() =>
//         Object.values(state.assets?.[dataType] ?? {})
//     )
//
//     const builtInAttributes = [
//         'id',
//         'repoId',
//         'dataType',
//         'appId',
//         'permissionHostDataType',
//         'permissionHostRepoId',
//         'parentDataType',
//         'parentId',
//         'slotCount',
//         'documentSequence'
//     ]
//     const createDocument = (properties) => {
//         const payload = {
//             ...properties,
//             dataType,
//         }; // shed the reactivity
//         if (dataType === "UserAccount") throw "User Account can not be created as document!";
//
//         if (permissionHostDataType && permissionHostRepoId) {
//             payload.permissionHostDataType = permissionHostDataType;
//             payload.permissionHostRepoId = permissionHostRepoId;
//         }
//
//         // move attributes to payload.attributes
//         payload.attributes = Object.fromEntries(
//             Object.entries(payload).reduce((entries, entry) => {
//                 const [key] = entry;
//                 if (!builtInAttributes.includes(key)) {
//                     entries.push(entry);
//                     delete payload[key];
//                 }
//                 return entries;
//             }, [])
//         );
//         return store.dispatch(CREATE_ASSET, payload)
//                 .then((result) => {
//                     return result
//                 })
//     };
//
//     const loadDocuments = (refresh, repoId) => {
//         const shouldLoad = (!filteredDocuments.value?.length
//                 || refresh)
//                 && !isEphemeral
//         if (shouldLoad) {
//             const options = {dataType};
//             if (repoId) options.repoId = repoId;
//             store.dispatch(LIST_ASSETS, options)
//         }
//     };
//     const deleteDocument = (id) => store.dispatch(DELETE_ASSET, {dataType, id});
//
//     const filter = ref({});
//
//     function filterDocument(doc) {
//         // eslint disable-next-line no-unused-vars
//         const applyAttributeFilter = (value, filterValue) => {
//             if (isString(value)) {
//                 value = value.toLowerCase();
//             }
//             if (isString(filterValue)) {
//                 filterValue = filterValue.toLowerCase();
//             }
//             if (isArray(filterValue)) {
//                 filterValue = filterValue.map((item) => {
//                     // if (isString(item)) {
//                     //     item.toLowerCase();
//                     // }
//                     return item;
//                 });
//             }
//             return (
//                 value === filterValue ||
//                 (isString(value) && value?.includes(filterValue)) || // partial match of contained commitment
//                 (isArray(value) &&
//                     [...value].find((item) => applyAttributeFilter(item, filterValue)))
//             );
//         };
//
//         const noFilter =
//             !isObject(filter.value) || !Object.keys(filter.value).length;
//
//         if (noFilter) return true
//
//         const params = Object.keys(filter.value);
//
//         let pass = params.reduce((pass, param) => {
//             return pass ||
//                 applyAttributeFilter(doc[param], filter.value?.[param]);
//         }, false);
//         // is not private or is private and has permission to view
//         // pass = pass && !doc.isPrivate || [permissionThresholds.manageApp, permissionThresholds.manageAsset].includes(doc._permissions)
//
//         return pass;
//     }
//
//     const filteredDocuments = ref(
//             Object.values(state.assets?.[dataType] ?? {})
//                     .filter(filterDocument)
//     );
//
//     watchPostEffect(() => {
//         const docs = Object.values(state.assets[dataType])
//         if (docs?.length) {
//             filteredDocuments.value = docs.filter(filterDocument)
//         }
//     })
//
//     if (shouldLoadDocuments.value) loadDocuments(true);
//
//     return {
//         createDocument,
//         deleteDocument,
//         documents,
//         filter,
//         filteredDocuments,
//         loadDocuments,
//         parentKey,
//     };
// };
import store, { state } from "../store/store";
import { computed, ref, watchPostEffect } from "vue";
import { useAssetActions } from "@/composables/lib/useAssetActions";
import { getDocumentKey } from "@/composables/lib/getDocumentKey";
import { CREATE_ASSET, DELETE_ASSET, LIST_ASSETS } from "@/store/operations";
import { isArray, isObject, isString } from "@/lib/getVariableType";
import config from "../../config";

const { appId } = config;

export const useDocuments = (
  documentType,
  {
    refresh,
    parentDataType,
    parentRepoId,
    permissionHostDataType,
    permissionHostRepoId,
    isEphemeral,
  } = {}
) => {
  const { dataType } = useAssetActions(documentType);
  const parentKey = getDocumentKey({
    appId,
    dataType: parentDataType,
    repoId: parentRepoId,
  });

  // Loading state
  const isLoading = ref(false);

  const shouldLoadDocuments = computed(() => {
    let pass = false;

    const isLoaded = documents.value?.length;
    pass ||= !isLoaded || refresh;

    const isLoggedIn = state.user?.name;
    pass &&= isLoggedIn || dataType !== "UserAccount";

    return pass;
  });

  const documents = computed(() =>
    Object.values(state.assets?.[dataType] ?? {})
  );

  const builtInAttributes = [
    "id",
    "repoId",
    "dataType",
    "appId",
    "permissionHostDataType",
    "permissionHostRepoId",
    "parentDataType",
    "parentId",
    "slotCount",
    "documentSequence",
  ];

  const createDocument = async (properties) => {
    const payload = {
      ...properties,
      dataType,
    }; // shed the reactivity

    if (dataType === "UserAccount")
      throw "User Account cannot be created as a document!";

    if (permissionHostDataType && permissionHostRepoId) {
      payload.permissionHostDataType = permissionHostDataType;
      payload.permissionHostRepoId = permissionHostRepoId;
    }

    // move attributes to payload.attributes
    payload.attributes = Object.fromEntries(
      Object.entries(payload).reduce((entries, entry) => {
        const [key] = entry;
        if (!builtInAttributes.includes(key)) {
          entries.push(entry);
          delete payload[key];
        }
        return entries;
      }, [])
    );

    try {
      isLoading.value = true; // Start loading
      const result = await store.dispatch(CREATE_ASSET, payload);
      return result;
    } finally {
      isLoading.value = false; // Stop loading
    }
  };

  const loadDocuments = async (refresh = false, repoId = null) => {
    const shouldLoad =
      (!filteredDocuments.value?.length || refresh) && !isEphemeral;
    if (shouldLoad) {
      const options = { dataType };
      if (repoId) options.repoId = repoId;

      try {
        isLoading.value = true; // Start loading
        await store.dispatch(LIST_ASSETS, options);
      } finally {
        isLoading.value = false; // Stop loading
      }
    }
  };

  const deleteDocument = async (id) => {
    try {
      isLoading.value = true; // Start loading
      await store.dispatch(DELETE_ASSET, { dataType, id });
    } finally {
      isLoading.value = false; // Stop loading
    }
  };

  const filter = ref({});

  function filterDocument(doc) {
    const applyAttributeFilter = (value, filterValue) => {
      if (isString(value)) {
        value = value.toLowerCase();
      }
      if (isString(filterValue)) {
        filterValue = filterValue.toLowerCase();
      }
      if (isArray(filterValue)) {
        filterValue = filterValue.map((item) => {
          return item;
        });
      }
      return (
        value === filterValue ||
        (isString(value) && value?.includes(filterValue)) ||
        (isArray(value) &&
          [...value].find((item) => applyAttributeFilter(item, filterValue)))
      );
    };

    const noFilter =
      !isObject(filter.value) || !Object.keys(filter.value).length;

    if (noFilter) return true;

    const params = Object.keys(filter.value);

    let pass = params.reduce((pass, param) => {
      return pass || applyAttributeFilter(doc[param], filter.value?.[param]);
    }, false);

    return pass;
  }

  const filteredDocuments = ref(
    Object.values(state.assets?.[dataType] ?? {}).filter(filterDocument)
  );

  watchPostEffect(() => {
    const docs = Object.values(state.assets[dataType]);
    if (docs?.length) {
      filteredDocuments.value = docs.filter(filterDocument);
    }
  });

  if (shouldLoadDocuments.value) loadDocuments(true);

  return {
    createDocument,
    deleteDocument,
    documents,
    filter,
    filteredDocuments,
    loadDocuments,
    parentKey,
    isLoading,
  };
};
